import { useEnergyContext } from '../../../../contexts/EnergyProvider'
import { capitalize } from '../../../../utils/helperFunctions'
import ChangesChildAction from './ChangesChildAction'

const EnergyChanges = () => {
  const context = useEnergyContext()
  return (
    <>
      {
        context?.energyIds && (
          context.energyIds.map((energyId) => <EnergyChangeBlock key={energyId} itemId={energyId} />)
        )
      }
    </>
  )
}


const EnergyChangeBlock = ({ itemId }: { itemId: number }) => {
  return <ChangesChildAction itemId={itemId} path="energyEntries" title="Energy" />
}

export default EnergyChanges